module.controller('confirmationCntrl', function($scope, $mdDialog, $window, $sce) {
    $scope.theme =  JSON.parse($window.sessionStorage.getItem("theme"));

    $scope.data = JSON.parse($window.sessionStorage.getItem('confirmDialog'));   
    $scope.closeDialog = function(){
        $mdDialog.cancel();
    };
    $scope.hideDialog = function(){
       var answer = true; 
       $window.sessionStorage.removeItem("confirmDialog");
       $mdDialog.hide(answer);
    };

    $scope.renderHtml = function (htmlCode) {
        return $sce.trustAsHtml(htmlCode);
      };
      
});